<template>
  <div>
    <cms-spotlight
      v-if="spotlightSetup"
      :theme="spotlightOptions"
      :content="homepage.spotlights[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

defineOptions({ name: 'ViewSpotlights' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const spotlightOptions = computed(() => ({
  ...theme.value?.containers?.[props.containerIdx]?.components?.[props.componentIdx]?.options,
  translations: {
    ...store.getters['translation/getComponentTranslation']('spotlight'),
    ...store.getters['translation/getGlobalTranslations'],
  },
  globalThemeSettings: store.getters.getGlobalThemeSettings,
}));

const spotlightSetup = computed(() => {
  const spotlight = homepage.value?.spotlights?.[id.value];
  return !isEmpty(spotlight?.content) || !isEmpty(spotlight?.nested_content);
});
</script>
